import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "hotkey",
  "use": "hotkey-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"hotkey\"><path d=\"M15 12a3 3 0 1 1-3 3v-2H8v2a3 3 0 1 1-3-3h2V8H5a3 3 0 1 1 3-3v2h4V5a3 3 0 1 1 3 3h-2v4h2Zm-8 1H5a2 2 0 1 0 1.995 2.15L7 15v-2Zm8 0h-2v2a2 2 0 1 0 2.15-1.995L15 13ZM5 3a2 2 0 0 0-.15 3.995L5 7h2V5a2 2 0 0 0-1.697-1.977l-.154-.018L5 3Zm10 0a2 2 0 0 0-1.995 1.85L13 5v2h2a2 2 0 0 0 1.995-1.85L17 5a2 2 0 0 0-2-2Zm-3 5H8v4h4V8Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol